import style from "./Icon.module.css"

const Icon = (props) => {
  function clicked(e) {
    if(props.onClick) {
      props.onClick(e);
    }
  }

  return <span className={`${style.icon} ${"material-symbols-outlined"} ${props.onClick && style.clickable} ${props.variants && props.variants.map((v) => style[v]).join(" ")}`} onClick={(e) => clicked(e)}>{props.children}</span>
}

export default Icon;